// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"1a10fb73","513":"88d4ea45"}[chunkId] + ".chunk.js";
};